// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3MZMp","content":"GlobalSearch_content__1VWij"};